import type {
  PartnerAddressV2,
  PartnerAddressUpsert,
  PartnerSearchAddressBooksParams,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const addresses = {
  search: {
    queryKey: 'partner-management-service/addresses',
    configurationType: 'default' as const,
    fn: async (params: PartnerSearchAddressBooksParams = {}) => {
      const { data } = await GatewayAxiosClient.get<PartnerAddressV2[]>(
        '/partner-management-proxy/api/v1/partners/addresses',
        { params },
      );

      return data;
    },
  },
  get: {
    queryKey: 'partner-management-service/addresses/id',
    configurationType: 'no-cache' as const,
    fn: async (addressId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerAddressV2>(
        `/partner-management-proxy/api/v1/partners/addresses/${addressId}`,
      );

      return data;
    },
  },
  update: async ({ addressId, payload: payload }: { addressId: string; payload: PartnerAddressUpsert }) => {
    const { data } = await GatewayAxiosClient.put<PartnerAddressV2>(
      `/partner-management-proxy/api/v1/partners/addresses/${addressId}`,
      payload,
    );

    return {
      data,
      invalidateQueryKeys: [
        ['partner-management-service/addresses'],
        ['partner-management-service/addresses/id', addressId],
      ],
    };
  },
  create: async (addressCreate: PartnerAddressUpsert) => {
    const { data } = await GatewayAxiosClient.post<PartnerAddressV2>(
      '/partner-management-proxy/api/v1/partners/addresses',
      addressCreate,
    );

    return { data, invalidateQueryKeys: [['partner-management-service/addresses']] };
  },
};
